<template>
  <el-card>
    <UserEdit v-if="isLoggedIn"></UserEdit>
    <h3 class="text-center" v-else>正在登陆...</h3>
  </el-card>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import UserEdit from "../components/UserEdit.vue";

export default {
  name: "home",
  props: {
    code: {
      type: String,
      required: false,
      default: ""
    },
    state: {
      type: String,
      required: false,
      default: ""
    }
  },
  computed: {
    ...mapGetters(["isLoggedIn"]),
    ...mapState(["user"])
  },
  mounted: function() {
    this.$axios
      .post(`/wechatLogin`, {
        code: this.code,
        state: this.state
      })
      .then(resp => {
        // login successfully
        if (resp.status == 201) {
          const token = resp.data.access_token;
          this.loginWithToken(token);
          // if (this.user.email) {
          //   this.$router.push("/");
          // }
        }
      })
      .catch(e => {
        this.$message({
          type: "error",
          message: "微信登录未成功，请稍后再试: " + e.response.data
        });
      });
  },
  watch: {
    "user.email": function(newVal, oldVal) {
      if (!oldVal && newVal) {
        this.$router.push("/");
      }
    }
  },
  methods: {
    ...mapMutations(["loginWithToken"])
  },
  components: {
    UserEdit
  }
};
</script>
